import { useClientI18nModelStore } from '@/models/client-i18n/clientI18n';
import type React from 'react';

type FormattedHTMLMessageProps = {
  id: string;
  values?: Record<string, string>;
  skipDomPure?: boolean;
  tagName?: keyof React.ReactHTML;
};

const removeSpecialSymbols = (text: string | number) => {
  return String(text)
    .replace(/<[^>]*>/g, '')
    .replace(/"/g, "'");
};

const FormattedHTMLMessage: React.FC<FormattedHTMLMessageProps> = ({
  id,
  values,
  skipDomPure,
  tagName = 'span',
}) => {
  const clientI18n = useClientI18nModelStore((x) => x.clientI18n);

  if (!clientI18n) {
    throw new Error('FormattedHTMLMessage must be used within a clientI18n');
  }

  const safeValues = values
    ? Object.fromEntries(
        // value should support simple React.ReactNode type
        Object.entries(values).map(([key, value]) => [
          key,
          skipDomPure ? value : removeSpecialSymbols(value),
        ]),
      )
    : {};
  const translatedContent = clientI18n(id as unknown as any, safeValues);

  // Create the HTML element with the translated content
  const TagName = tagName;
  return (
    <TagName
      dangerouslySetInnerHTML={{
        __html: translatedContent || '',
      }}
    />
  );
};

export default FormattedHTMLMessage;
